module.exports = __webpack_public_path__ + "img/pro_one_5.b86cd6c2.jpg";